<template>
  <div class="current-wrapper">
    <div class="gauge gauge--current">
      <div class="gauge__background">
        <div class="gauge__dial-center">
          <div class="gauge__dial-center__indicator" />
        </div>
      </div>
      <div class="current-content">
        {{ current }}mA<br>
        <span
          v-if="showExpected"
          class="current-content__expected"
        >
          <strong :style="{color: computeStrokeColor}">
            {{ expectedCurrent + 'mA' }}
          </strong> expected
        </span>
      </div>

      <div
        v-if="showExpected"
        class="current__expected-wrapper"
      >
        <svg
          class="current__expected"
          width="165"
          height="165"
          viewBox="0 0 120 120"
        >
          <circle
            class="current__expected__value"
            cx="60"
            cy="60"
            r="54"
            fill="none"
            stroke="#f77a52"
            stroke-width="7"
            :style="{stroke: computeStrokeColor, strokeDashoffset: computeExpectedCurrentGauge}"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import GaugeLib from '@/assets/javascript/GaugeLib.js'

export default {
  props:
  {
    current: {
      type: Number,
      default: null
    }
  },
  data() {
    return{
      MaxValue: 600,
      expectedCurrent: this.current,
      currentGauge: null,
      showExpected: false
    }
  },
  computed: {
    computeStrokeColor() {
      return '#71c837'
    },
    computeExpectedCurrentGauge() {
      const val = 339.292 - ((97 / this.MaxValue) * this.expectedCurrent)
      return val
    }
  },
  watch: {
    current() {
      this.currentGauge.update(this.current)
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.currentGauge = new GaugeLib()

      this.currentGauge.config({
        el: '.gauge.gauge--current',
        dialEl: '.gauge__dial-center',
        dialStart: -48.7,
        dialEnd: 48.7,
        forcedUpperValue: this.MaxValue,
        maxValue: this.MaxValue,
        status: 'active',
        baseTransform: 'translate3d(-50%, 488%, 0px)'
      })
      this.currentGauge.update(this.current)
    })
  }
}
</script>

<style lang="scss">
  /* Voltage Gauge TR */
  .current-wrapper {
    display: flex;
    justify-content: center;
    margin: 0;
    transform: translateX(-5px);
  }

  .current {
    &__expected-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-49.8%, 0%, 0);
      z-index: -1;
      transition: all 0.5s;
    }
    &__expected {
      &__value {
        transform-origin: center;
        transform: rotate(-141.5deg);
        stroke-dasharray: 339.292;
        stroke-dashoffset: 339.292;
        stroke: #7C99BA;
        transition: stroke-dashoffset 0.4s;
      }
    }
  }

  .gauge.gauge--current,
  .gauge.gauge--current .gauge__background {
    width: 244px;
    height: 120px;
    margin: 0;
  }

  .gauge.gauge--current .gauge__background {
    background: url('~@graphics/current_gauge.svg') center center;
    width: 100%;
    height: 100%;
    background-size: cover;
    border-radius: 0;
  }

  .gauge.gauge--current .gauge__dial-center {
    transform: translate3d(-50%, 488%, 0px) rotateZ(0deg);
    background: #fff;
  }

  .gauge.gauge--current .gauge__dial-center__indicator {
    height: 45px;
    transform: translate3d(-50%,-260%,0) rotate(0deg);
    transform-origin: 50% 100%;

    // &--overcurrent {
    //   background: $color-red;
    // }
  }

  .current-wrapper .current-content
  {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    text-align: center;
    color: #000;

    &__expected {
      font-size: 13px;
    }

    // &--overcurrent {
    //   color: $color-red;
    // }
  }
</style>
